import * as React from "react";
import { Badge } from "antd";

/**
 * StatusBadge Component
 * 
 * Displays a status badge with appropriate color coding based on the status value.
 * Used for displaying processing status in table cells.
 * 
 * @param {Object} props - Component props
 * @param {"uploaded" | "processing" | "success" | "complete" | "completed" | "error" | "failed"} props.status - The status to display
 * @returns {JSX.Element} The status badge component
 */
function StatusBadge({ status }) {
  const getBadgeStatus = (status) => {
    if (status === "uploaded" || status === "complete" || status === "completed") return "success";
    if (status === "error" || status === "failed") return "error";
    return "processing";
  };

  return <Badge status={getBadgeStatus(status)} text={status} />;
}

/**
 * ScanUploadStatus Component
 * 
 * Displays a status badge showing upload progress for scan files.
 * Shows the count of uploaded files vs total files.
 * 
 * @param {Object} props - Component props
 * @param {Array} props.scanUploads - Array of scan upload objects with status
 * @returns {JSX.Element} The scan upload status component
 */
function ScanUploadStatus({ scanUploads }) {
  const getBadgeStatus = (status) => {
    if (status === "uploaded") return "success";
    return "processing";
  };

  console.log('scanUploads', scanUploads);

  let status = "default";
  let statusText = "";
  if(scanUploads) {
    const uploadedCount = scanUploads.filter((upload) => upload.status === "uploaded").length;
    const totalCount = scanUploads.length;
    if (uploadedCount === totalCount) {
      status = "success";
    } else if (uploadedCount > 0) {
      status = "processing";
    }
    statusText = `${uploadedCount} / ${totalCount} uploaded`; 
  }

  return <Badge status={getBadgeStatus(status)} text={statusText} />;
}

/**
 * TableListCellItems
 * 
 * Collection of reusable table cell components for displaying status information.
 * Provides standardized status display components used across the application.
 * 
 * @type {Object}
 */
export const TableListCellItems = {
  StatusBadge,
  ScanUploadStatus,
};
